import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, createStaticVNode as _createStaticVNode } from "vue"
import _imports_0 from '../assets/logo-abaccus.svg'


const _hoisted_1 = {
  class: "navbar",
  role: "navigation",
  "aria-label": "main navigation"
}
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "navbar-brand mr-5" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1)
const _hoisted_5 = {
  id: "navbarBasicExample",
  class: "navbar-menu"
}
const _hoisted_6 = { class: "navbar-start" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", null, " Licenças ", -1)
const _hoisted_8 = { class: "navbar-end" }
const _hoisted_9 = { class: "navbar-item" }
const _hoisted_10 = { class: "dropdown-trigger" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", { class: "icon" }, [
  /*#__PURE__*/_createElementVNode("i", {
    class: "fa-solid fa-circle-user",
    style: {"font-size":"x-large"}
  })
], -1)
const _hoisted_12 = [
  _hoisted_11
]
const _hoisted_13 = {
  class: "dropdown-menu",
  id: "dropdown-menu",
  role: "menu"
}
const _hoisted_14 = { class: "dropdown-content" }
const _hoisted_15 = /*#__PURE__*/_createStaticVNode("<div href=\"#\" class=\"dropdown-item\"><div class=\"is-flex is-flex-direction-column is-align-items-center\"><span class=\"icon\"><i class=\"fa-solid fa-user\" style=\"font-size:xx-large;\"></i></span><span class=\"mt-3\">Logado como:</span><span>usuario@dominio</span></div></div><hr class=\"dropdown-divider\"><a href=\"#\" class=\"dropdown-item\"> Gerenciar Conta </a>", 3)
const _hoisted_18 = { class: "dropdown-item" }
const _hoisted_19 = { class: "field" }
const _hoisted_20 = ["checked"]
const _hoisted_21 = /*#__PURE__*/_createElementVNode("label", { for: "switchExample" }, " Modo Escuro ", -1)

import { computed, ref } from 'vue';
  import { useRoute } from 'vue-router';
  import { vOnClickOutside } from '@vueuse/components';
  import { useDark, useToggle } from '@vueuse/core';

  
export default /*#__PURE__*/_defineComponent({
  __name: 'NavBar',
  setup(__props) {

  const isDark = useDark();
  const toggleDark = useToggle(isDark);

  const route = useRoute();
  const currentRouteName = computed(() => route.name);
  const settingsActive = ref(false);

  function fechaDropdown() {
    settingsActive.value = false;
  }

return (_ctx: any,_cache: any) => {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock("nav", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_RouterLink, {
          to: "/",
          class: "navbar-item"
        }, {
          default: _withCtx(() => [
            _hoisted_4
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_RouterLink, {
            to: "/",
            class: _normalizeClass(["navbar-item is-tab", { 'is-active': currentRouteName.value === 'licencas' }])
          }, {
            default: _withCtx(() => [
              _hoisted_7
            ]),
            _: 1
          }, 8, ["class"])
        ])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          _withDirectives((_openBlock(), _createElementBlock("div", {
            class: _normalizeClass(["dropdown is-right", { 'is-active': settingsActive.value }])
          }, [
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("button", {
                class: "button is-rounded",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (settingsActive.value = !settingsActive.value))
              }, _hoisted_12)
            ]),
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("div", _hoisted_14, [
                _hoisted_15,
                _createElementVNode("div", _hoisted_18, [
                  _createElementVNode("div", _hoisted_19, [
                    _createElementVNode("input", {
                      id: "switchExample",
                      type: "checkbox",
                      name: "switchExample",
                      class: "switch is-rounded is-small is-rtl",
                      checked: _unref(isDark),
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(toggleDark)()))
                    }, null, 8, _hoisted_20),
                    _hoisted_21
                  ])
                ]),
                _createElementVNode("a", {
                  href: "#",
                  class: "dropdown-item",
                  onClick: fechaDropdown
                }, " Fechar")
              ])
            ])
          ], 2)), [
            [_unref(vOnClickOutside), fechaDropdown]
          ])
        ])
      ])
    ])
  ]))
}
}

})